var map = {
	"./icon-globe-error.svg": "./src/assets/icon-globe-error.svg",
	"./icon-globe.svg": "./src/assets/icon-globe.svg",
	"./icon-monitor.svg": "./src/assets/icon-monitor.svg",
	"./icon-server.svg": "./src/assets/icon-server.svg",
	"./logo.svg": "./src/assets/logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*\\.svg$";